<div [hidden]="!loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<app-table [rows]="rows" [columns]="columns" [batch]="true" (sort)="onSort($event)" (changeBatch)="onChangeBatch($event)" (action)="onAction($event)"
  (cellClick)="onCellClick($event)">
</app-table>
<div class="d-flex justify-content-between align-items-center my-15 has-pagination">
  <div class="pagination-left">
    <app-pagination *ngIf="totalCount > currentSize" [totalItems]="totalCount" [currentPage]="page" (change)="onPageChange($event)"
      [pageSize]="currentSize"></app-pagination>
  </div>
  <div class="d-flex align-items-center justify-content-end pagination-right">
    <span class="pagination-count">Showing {{ rows.length }} of {{ totalCount }} sms</span>
    <ul *ngIf="sizes.length" class="pagination">
      <li *ngFor="let size of sizes" [ngClass]="{ active: size === currentSize }">
        <a (click)="onChangeSize(size)">{{ size }}</a>
      </li>
    </ul>
  </div>
</div>
